import { JobsAction } from './jobs/actions';

export enum SharedActionType {
  SetRole = 'SetRole',
}

export type SharedStateActions = JobsAction | ReturnType<typeof setRole>;

// Generic shared state actions
export const setRole = (role: string) => ({
  type: SharedActionType.SetRole as const,
  payload: role,
});

export * from './jobs/actions';
